import { render, staticRenderFns } from "./setting-payments.vue?vue&type=template&id=f0ae3b16"
import script from "./setting-payments.vue?vue&type=script&lang=js"
export * from "./setting-payments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports